import { Button, Collapse, message, Spin, Table, Typography } from "antd";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import TableEmptyContent from "../../Components/TableEmptyContent/TableEmptyContent";
import { escalatedcolumns, items, topfivecolumns } from "./DashboardUtils";
import BottomTab from "../../Components/BottomTab/BottomTab";
import { DashboardAPI } from "../../API/DashboardAPI";
import { FlightModalAPI } from "../../API/FlightModalAPI";
import { useFlightModel } from "../../contexts/FlightModelContext";
const { Text } = Typography;

export default function Dashboard() {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [spinning, setSpinning] = useState(false);
  const [topfivedata, setTopfivedata] = useState([]);
  const [escalationdata, setEscalationData] = useState([]);
   const { selectedFlightModel,setSelectedFlightModel, refreshFlightModels } = useFlightModel();
   console.log("selectedFlightModel",selectedFlightModel);
   
    const messageToast = useCallback((type, message) => {
  messageApi.open({
    type,
    content: message,
    duration: 6,
  });
}, [messageApi]);


  // async function getData() {
  //   setSpinning(true);
  //   await FlightModalAPI.getFlightModals()
  //     .then((response) => {
  //       if (response?.data?.status === true) {
  //         localStorage.setItem(
  //           "flight_model",
  //           response?.data?.selected_flight_model,
  //         );

  //         const queryParams = {
  //           params: {
  //             flight_model:
  //               response?.data?.selected_flight_model ||
  //               localStorage.getItem("flight_model"),
  //           },
  //         };
  //         DashboardAPI.getTableData(queryParams)
  //           .then((res) => {
  //             if (res.data?.status === true) {
  //               setTopfivedata(res?.data?.rank_data);
  //               setEscalationData(res?.data?.escalated_data);
  //             } else {
  //               messageToast("error", res.data.message);
  //             }
  //           })
  //           .catch((err) => {
  //             messageToast("error", "Internal Server Error");
  //           })
  //           .finally(() => {
  //             setSpinning(false);
  //           });
  //       } else {
  //         messageToast("error", response?.data?.message);
  //       }
  //     })
  //     .catch(() => messageToast("error", "Internal Server Error"));
  // }
  const getData = useCallback(async () => {
  try {
    setSpinning(true);

    let flightModelToUse = selectedFlightModel;

    // Fallback: fetch from context if not available
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    // If still not available → stop
    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }

    // Optional: keep localStorage sync (if other parts depend on it)
    // localStorage.setItem("flight_model", flightModelToUse);
    
                         setSelectedFlightModel(flightModelToUse);
    

    const queryParams = {
      params: {
        flight_model: flightModelToUse,
      },
    };

    const res = await DashboardAPI.getTableData(queryParams);

    if (res?.data?.status === true) {
      setTopfivedata(res?.data?.rank_data);
      setEscalationData(res?.data?.escalated_data);
    } else {
      messageToast("error", res?.data?.message);
    }
  } catch (error) {
    messageToast("error", "Internal Server Error");
  } finally {
    setSpinning(false);
  }
}, [selectedFlightModel, refreshFlightModels, messageToast,setSelectedFlightModel]);

  useEffect(() => {
    getData();
  }, []);

  // const messageToast = (type, message) => {
  //   messageApi.open({
  //     type: type,
  //     content: message,
  //     duration: 6,
  //   });
  // };
  

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimzer | Dashboard</title>
      </Helmet>

      <HeaderTab currrentTab="dashboard" />

      <div className="disboard_div">
        <div className="left_wraper">
          <Spin spinning={spinning}>
            <div className="box_wraper_div">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
                <Text className="table_head">
                  Your top 5 Specs for this month{" "}
                </Text>
                <Button
                  onClick={() => navigate("/ranking")}
                  type="primary"
                  style={{ margin: "0px 10px" }}
                >
                  View All
                </Button>
              </div>
              <Table
                rowKey="id"
                columns={topfivecolumns}
                dataSource={topfivedata}
                pagination={{
                  position: ["none", "none"],
                }}
                style={{ marginBottom: "10px" }}
                className="antdTable"
                locale={{
                  emptyText: <TableEmptyContent />,
                }}
              />
            </div>
          </Spin>

          <Spin spinning={spinning}>
            <div className="box_wraper_div">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
                <Text className="table_head">
                  Escalation Completed Items for this month{" "}
                </Text>
                <Button
                  onClick={() => navigate("/escalationCompleted")}
                  type="primary"
                  style={{ margin: "0px 10px" }}
                >
                  View All
                </Button>
              </div>
              <Table
                rowKey="id"
                columns={escalatedcolumns}
                dataSource={escalationdata}
                pagination={{
                  position: ["none", "none"],
                }}
                style={{ marginBottom: "10px" }}
                className="antdTable"
                locale={{
                  emptyText: <TableEmptyContent />,
                }}
              />
            </div>
          </Spin>
        </div>

        <div className="right_wraper">
          <Text style={{ fontSize: "17px", fontWeight: 600 }} type="">
            Info
          </Text>
          <div className="exclude_box_wraper_div">
            <Collapse
              bordered={false}
              accordion={true}
              items={items}
              defaultActiveKey={[]}
              expandIcon={({ isActive }) =>
                isActive ? <CaretUpOutlined /> : <CaretDownOutlined />
              }
              expandIconPosition="end"
              style={{
                backgroundColor: "transparent",
              }}
            />
          </div>
        </div>
      </div>

      <BottomTab />
      {contextHolder}
    </div>
  );
}
